module.exports = "https://coursera_assets.s3.amazonaws.com/images/685d99103854d0e81845c85e5aefdd1b.png";